import PropTypes from "prop-types"
import * as css from "./FilterBar.module.css"

/**
 * FilterBar — reusable pill-button filter strip.
 *
 * filters: [{ id, label }]  — id=null means "All"
 * activeFilter: the currently active id (null = all)
 * onChange: (id) => void
 */
function FilterBar({ filters, activeFilter, onChange, className }) {
  return (
    <div className={`${css.filterBar}${className ? ` ${className}` : ""}`}>
      {filters.map((filter) => (
        <button
          key={String(filter.id)}
          type="button"
          aria-pressed={activeFilter === filter.id}
          className={`${css.filterButton} ${
            activeFilter === filter.id ? css.filterButtonActive : ""
          }`}
          onClick={() => onChange(filter.id)}
        >
          {filter.label}
        </button>
      ))}
    </div>
  )
}

FilterBar.propTypes = {
  filters: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.any,
      label: PropTypes.string.isRequired,
    })
  ).isRequired,
  activeFilter: PropTypes.any,
  onChange: PropTypes.func.isRequired,
  className: PropTypes.string,
}

export default FilterBar
